<app-loading *ngIf="isLoading$ | async"></app-loading>
<app-error-message *ngIf="error$ | async"></app-error-message>

<div *ngIf="feed$ | async">
  <div class="article-preview" *ngFor="let article of (feed$ | async).articles">
    <div class="article-meta">
      <a [routerLink]="['/profiles', article.author.username]">
        <img [src]="article.author.image" alt="Image" />
      </a>
      <div class="info">
        <a [routerLink]="['/profiles', article.author.username]">
          {{ article.author.username }}
        </a>
        <span class="date"> {{ article.createdAt }}</span>
      </div>
      <div class="pull-xs-right">
        <app-likes
          [articleSlug]="article.slug"
          [favoritesCountProps]="article.favoritesCount"
          [isFavoriteProps]="article.favorited"
        ></app-likes>
      </div>
    </div>
    <a [routerLink]="['/articles', article.slug]" class="preview-link">
      <h1>{{ article.title }}</h1>
      <p>{{ article.description }}</p>

      <app-tag-list [tags]="article.tagList"></app-tag-list>
    </a>
  </div>

  <app-pagination [totalCount]="(feed$ | async)?.articlesCount" [limit]="10" [url]="baseUrl" [currentPage]="currentPage"></app-pagination>
</div>
